export class ServiceRequestsUsers {
  id: string;
  userId: string;
  isRead: boolean;
}
